export default {
  formData: (state) => state.formData,
  sorting: (state) => state.sorting,
  isLoading: (state) => state.loading,
  actionLoading: (state) => state.actionLoading,
  range: (state) => state.range,
  items: (state) => state.items,
}
